"use client";

import dynamic from "next/dynamic";
import { SlideImage } from "yet-another-react-lightbox";

import Spinner from "./spinner";

// Dynamically import the entire lightbox functionality
const ClientLightbox = dynamic(() => import("./lightbox-client"), {
	ssr: false,
	loading: () => (
		<div
			style={{
				width: "100%",
				maxWidth: "100%",
				aspectRatio: 1.2,
				margin: "0 auto",
				backgroundColor: "#010311",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			}}
		>
			<Spinner size={2} />
		</div>
	),
});

const Lightbox = ({ images }: { images: SlideImage[] }) => {
	return <ClientLightbox images={images} />;
};

export default Lightbox;
